enum VehicleTypeEnum {
  Truck = 1,
  Train,
}

export { VehicleTypeEnum };
